import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.21 12.365a.6.6 0 0 1 .062.846l-5.251 6.066c-.324.457-.802.596-1.203.596H7.27c-.016 0-.063 0-.11-.005a.7.7 0 0 1-.415-.188l-.04-.038a1.1 1.1 0 0 1-.429-.66 1.1 1.1 0 0 1 .115-.738l3.273-5.636a.6.6 0 1 1 1.038.602l-3.172 5.463h1.29c.07 0 .119-.012.149-.026a.2.2 0 0 0 .078-.07 1 1 0 0 1 .046-.06l5.272-6.091a.6.6 0 0 1 .847-.062",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.527 7.085A.6.6 0 0 1 2 6.855h2.727c.2 0 .388.1.5.267l1.64 2.46h12.406c1.773 0 3.327 1.437 3.327 3.327a2.424 2.424 0 0 1-2.418 2.418h-6.91a.6.6 0 0 1 0-1.2h6.91c.668 0 1.218-.55 1.218-1.218a2.135 2.135 0 0 0-2.127-2.127H6.545a.6.6 0 0 1-.499-.267l-1.64-2.46H2.768l.723 2.89a.6.6 0 0 1-.158.57l-.417.417L4.8 13.327c.748.496 1.539.8 2.383.8h2a.6.6 0 1 1 0 1.2h-2c-1.152 0-2.175-.42-3.06-1.01l-.025-.017-2.454-1.818a.6.6 0 0 1-.067-.906l.669-.67L1.418 7.6a.6.6 0 0 1 .11-.515",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.337 4.428c.207-.207.481-.3.754-.3h1.545c.198 0 .412.031.61.11.169.068.377.192.516.41l4.507 5.138a.6.6 0 1 1-.902.792L9.822 5.396l-.039-.05-.048-.01a1 1 0 0 0-.099-.009H8.4l2.575 4.464a.6.6 0 0 1-1.04.6L7.293 5.81a.7.7 0 0 1-.213-.314c-.046-.138-.043-.284-.043-.311v-.004c0-.273.094-.547.301-.754",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }